export const projects = [  
  {
    title: "Epic Todo App",
    subtitle: "React Hooks",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
    image: "./project-4.gif",
    link: "https://reactbootcamp.com",
  },
];

export const testimonials = [
  {
    quote:
      "A framework for souce code quality measurement",
    image: "/springer-oocqm.webp",
    name: "OOCQM",
    link:"https://rd.springer.com/chapter/10.1007/978-3-030-25225-0_11",
    company: "Springer",
  },
  {
    quote:
      " A framework for website's usability measurement",
    image: "/springer-ggse.webp",
    link:"https://rd.springer.com/chapter/10.1007/978-3-030-01177-2_31",
    name: "GGSE",
    company: "Springer",
  },
];

export const skills = [
  "PHP",
  "Laravel",
  "JavaScript",
  "jQuery",
  "React.js",
  "Node",
  "mySQL",
  "Redis",
  "mongoDB",
  
];



// WEBPACK FOOTER //
// ./src/data.js